<script>
export default {
  name: "TheActionHeaderCardArch",

  props : {
    achievementComments: Array,
  },

  computed: {
    isCommentsDeleteAchievementPresent() {
      return _.filter(this.achievementComments, comment => comment.comment_type === 'delete_achievement')?.length > 0 || false;
    },

    isCommentsEditAchievementPresent() {
      return _.filter(this.achievementComments, comment => comment.comment_type === 'edit_achievement')?.length > 0 || false;
    },
  },
}
</script>

<template>
  <v-card-title class="d-flex flex-row pb-0">
    <v-icon left small @click="$emit('openInfo')">
      fa fa-info
    </v-icon>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">

        <v-icon
          v-show="isCommentsDeleteAchievementPresent"
          small
          right
          color="warning"
          v-bind="attrs"
          v-on="on"
          @click="$emit('editAchievement')"
        >
          fa-exclamation-triangle
        </v-icon>
      </template>
      <span>Есть замечания</span>
    </v-tooltip>

    <v-spacer/>

    <div class="d-flex">

      <template v-if="isCommentsEditAchievementPresent">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn

              class="mr-1"
              icon
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon small color="teal darken-3">fa-certificate</v-icon>
            </v-btn>
          </template>
          <span>Отредактировано комиссией</span>
        </v-tooltip>
      </template>

      <v-btn
        v-else
        class="mr-1"
        icon
        @click="$emit('editAchievement')"
        small
      >
        <v-icon small>fa-edit</v-icon>
      </v-btn>

      <v-btn
        v-if="!isCommentsEditAchievementPresent"
        icon
        class="ml-1"
        @click="$emit('deleteAchievement')"
        small
      >
        <v-icon small>fa-trash</v-icon>
      </v-btn>
    </div>
  </v-card-title>
</template>

<style scoped>

</style>